import React from "react"
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import { HashRouter as Router } from "react-router-dom"
import { ThemeProvider, useTheme } from "./context/ThemeContext"
import { AuthProvider, useAuth } from "./context/AuthContext"
import AppRoutes from "./routes/Routes"
import "./styles/global.css"
import { getDesignTokens } from "./theme"
import { CircularProgress, Box } from "@mui/material"
import { startTokenRefresher } from "./services/tokenRefresher"
import { MultipleWebSocketProvider } from "./context/MultipleWebSocketContext"

const LoadingScreen = () => (
  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
    <CircularProgress />
  </Box>
)

const ThemedApp = () => {
  const { mode } = useTheme()
  const { loading, user } = useAuth()
  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode])

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", mode)
  }, [mode])

  React.useEffect(() => {
    if (user) {
      const refresherInterval = startTokenRefresher()
      return () => clearInterval(refresherInterval)
    }
  }, [user])

  if (loading) {
    return <LoadingScreen />
  }

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <AppRoutes />
    </MuiThemeProvider>
  )
}

const App = () => (
  <ThemeProvider>
    <Router>
      <AuthProvider>
        <MultipleWebSocketProvider>
          <ThemedApp />
        </MultipleWebSocketProvider>
      </AuthProvider>
    </Router>
  </ThemeProvider>
)

export default App
